export default __webpack_public_path__ + "static/media/disable-video.6dc56a6f.svg";